import { INotificationRole } from "models/NotificationRoleModel";
import { BaseService } from "./base.service";

class NotificationRoleServiceInternal extends BaseService {
	getNotificationRoleList = async (): Promise<INotificationRole[]> =>
		this.callApi<INotificationRole[]>(
			`NotificationRole/GetNotificationRoleList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const NotificationRoleService = new NotificationRoleServiceInternal();
